import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Users, CheckCircle2, Clock, Search, MapPin, Building2, UserSearch, Download, ClipboardList } from 'lucide-react'
import * as XLSX from 'xlsx'
import {
  Bar, BarChart, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList, Cell,
  LineChart, Line, CartesianGrid,
} from 'recharts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useDocumentTitle } from '@/shared/hooks/use-document-title'

// ── Tipos ──────────────────────────────────────────────────────────────────

type Estado = 'confirmado' | 'pendiente' | 'cancelado'

interface RegistroAdium {
  nombre: string
  email: string
  telefono: string
  estado: Estado
  fecha_registro: string
  ciudad: string
  localidad: string
  fecha_evento: string
  especialidad: string
  representante: string
}

// ── Constantes ──────────────────────────────────────────────────────────────

const PURPLE = '#6a5cbc'
const PURPLE_LIGHT = '#6a5cbc18'
const SHADES = ['#6a5cbc', '#7d71c9', '#9186d6', '#a49be3', '#c4bef0']

const EVENTO = {
  nombre: 'Inteligencia Artificial y Vonoprazan',
  subtitulo: 'La nueva frontera científica en el manejo de las enfermedades ácido-pépticas',
  periodo: 'Septiembre 2026',
}

// ── Data real extraída de BD de producción (formularios-registro) ─────────────

const REGISTROS: RegistroAdium[] = [
  {
    nombre: 'Juan Carlos Diaz',
    email: 'juandiazve@gmail.com',
    telefono: '593960402000',
    estado: 'confirmado',
    fecha_registro: '2026-08-25',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Gabriel Gastón Medina Barcia',
  },
  {
    nombre: 'María Monserrate Briceño Kirby',
    email: 'mmbkirby@gmail.com',
    telefono: '593987500821',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Cristina Del Rocio Arevalo Molina',
  },
  {
    nombre: 'Ivan Alexander Ayabaca Povea',
    email: 'ayabacalex@yahoo.es',
    telefono: '593984912100',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Pedro Ramiro Vargas Brandt',
  },
  {
    nombre: 'Geoconda Terranova',
    email: 'drgeoconda@hotmail.com',
    telefono: '593999601303',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Juan Pablo Alvarez Duque',
  },
  {
    nombre: 'Rosalina Bajaña Avila',
    email: 'robajana@yahoo.es',
    telefono: '593998293701',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Juan Carlos Ulloa Correa',
  },
  {
    nombre: 'Estefania Nemer Castro',
    email: 'alviteins777@hotmail.com',
    telefono: '593981018427',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Juan Carlos Ulloa Correa',
  },
  {
    nombre: 'Magda Maribel Arevalo Luzuriaga',
    email: 'mmaribelarevalol10@ymail.com',
    telefono: '593984912099',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: '',
    representante: 'Pedro Ramiro Vargas Brandt',
  },
  {
    nombre: 'Roberto Salazar Molina',
    email: 'mdroberto1513@gmail.com',
    telefono: '593981170680',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Juan Carlos Ulloa Correa',
  },
  {
    nombre: 'Galo Pazmiño',
    email: 'gpazminoq@puce.edu.ec',
    telefono: '593999202855',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: '',
    representante: 'Freddy Reinaldo Usca Usca',
  },
  {
    nombre: 'Ligia Elena Basantes',
    email: 'lielen_4@hotmail.com',
    telefono: '593995065170',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Freddy Reinaldo Usca Usca',
  },
  {
    nombre: 'Marjorie Ordoñez',
    email: 'maordonez79@hotmail.com',
    telefono: '593987945719',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Freddy Reinaldo Usca Usca',
  },
  {
    nombre: 'Pablo Ricardo Abad Reyes',
    email: 'parri61@hotmail.com',
    telefono: '593963604695',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: '',
    representante: 'Freddy Reinaldo Usca Usca',
  },
  {
    nombre: 'Susana Margoth López Chipantasi',
    email: 'susanamargothlopez@gmail.com',
    telefono: '593998151026',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Freddy Reinaldo Usca Usca',
  },
  {
    nombre: 'Andrea Abad',
    email: 'andrea_abad96@hotmail.com',
    telefono: '593992623861',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Freddy Reinaldo Usca Usca',
  },
  {
    nombre: 'Maria Luisa Jara Alba',
    email: 'marialuisajaraalba@hotmail.com',
    telefono: '593992134753',
    estado: 'confirmado',
    fecha_registro: '2026-09-02',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Gabriel Gastón Medina Barcia',
  },
  {
    nombre: 'Elizabeth Maizury Garzon Mayorga',
    email: 'maizurex_13@hotmail.com',
    telefono: '593985061971',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Gabriel Gastón Medina Barcia',
  },
  {
    nombre: 'Andrea Vera',
    email: 'dra.andreaverasantana@gmail.com',
    telefono: '593994455044',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Paúl Molina',
    email: 'pmolinad49@hotmail.es',
    telefono: '593987015490',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Freddy Reinaldo Usca Usca',
  },
  {
    nombre: 'Ruben Gustavo Muñoz Cedeño',
    email: 'drubenmunoz@gmail.com',
    telefono: '593979981214',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Juan Carlos Ulloa Correa',
  },
  {
    nombre: 'María de Los Ángeles Campaña',
    email: 'angeles_campana@hotmail.com',
    telefono: '593939513183',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Cristina Del Rocio Arevalo Molina',
  },
  {
    nombre: 'Cecil Giovanni Castellanos Suarez',
    email: 'giovanni@gastrogcastellanos.com',
    telefono: '593999449188',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Cristina Del Rocio Arevalo Molina',
  },
  {
    nombre: 'Cesar Saul Oviedo Valdiviezo',
    email: 'cesarsauloviedo55@hotmail.com',
    telefono: '593999417541',
    estado: 'pendiente',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Cristina Del Rocio Arevalo Molina',
  },
  {
    nombre: 'Marco Enrique Luna Espinel',
    email: 'lunamarco90@hotmail.com',
    telefono: '5939994596969',
    estado: 'pendiente',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Cristina Del Rocio Arevalo Molina',
  },
  {
    nombre: 'Wendy Patricia Calderón Cuaspud',
    email: 'wendycalderon_d2011@hotmail.com',
    telefono: '593987280286',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Cristina Del Rocio Arevalo Molina',
  },
  {
    nombre: 'Gladys Maria Calderón Panchi',
    email: 'glamcp@yahoo.es',
    telefono: '593999226521',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Cristina Del Rocio Arevalo Molina',
  },
  {
    nombre: 'Juan Esteban Yepez Naranjo',
    email: 'cangurojuan@hotmail.com',
    telefono: '593995833831',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Cristina Del Rocio Arevalo Molina',
  },
  {
    nombre: 'Milton Efrain Carrera Carrera',
    email: 'meccarrera2506@gmail.com',
    telefono: '593982448018',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Andrea Carina Molina Andrade',
  },
  {
    nombre: 'Andrés Reyes Fierro',
    email: 'andres_reyesf@hotmail.com',
    telefono: '593999211141',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Aníbal Rolando Guerrero Portugal',
  },
  {
    nombre: 'Adnan Sayah',
    email: 'adnan_66br@yahoo.es',
    telefono: '593998015349',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: '',
    representante: 'Aníbal Rolando Guerrero Portugal',
  },
  {
    nombre: 'Luis Salas',
    email: 'luissalas70@hotmail.com',
    telefono: '593999597823',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Aníbal Rolando Guerrero Portugal',
  },
  {
    nombre: 'Karla Elvita Murgueytio Salazar',
    email: 'murgueytito@hotmail.com',
    telefono: '593992782190',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Aníbal Rolando Guerrero Portugal',
  },
  {
    nombre: 'Manuel Alfredo Moncayo Guillén',
    email: 'manuelmoncayo50@gmail.com',
    telefono: '593969067874',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Manuel Alejandro Guaranda Maya',
    email: 'manuel_guaranda@hotmail.com',
    telefono: '593995342221',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Juan Carlos Ulloa Correa',
  },
  {
    nombre: 'Vielka Cedeño',
    email: 'vibeca78@hotmail.com',
    telefono: '593985769357',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Hernán Padilla Lopez',
    email: 'doctorpady@hotmail.com',
    telefono: '593999836883',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Freddy Reinaldo Usca Usca',
  },
  {
    nombre: 'Steve Alexander Padilla Paredes',
    email: 'stevepadilla2201@gmail.com',
    telefono: '593995832831',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Freddy Reinaldo Usca Usca',
  },
  {
    nombre: 'Mónica Susana Caballero Giler',
    email: 'msusanacaballero@hotmail.com',
    telefono: '593991164072',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Thalin Michelle Campi Mera',
  },
  {
    nombre: 'Cristina Nathaly Zambrano Rosero',
    email: 'crnzambrano_md@hotmail.com',
    telefono: '593984112134',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Aníbal Rolando Guerrero Portugal',
  },
  {
    nombre: 'Inés Verónica Guevara Peñaranda',
    email: 'draveronicaguevara@gmail.com',
    telefono: '593967638198',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Thalin Michelle Campi Mera',
  },
  {
    nombre: 'Jorge Javier Plua Onofre',
    email: 'javierplua@hotmail.com',
    telefono: '593983861575',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Thalin Michelle Campi Mera',
  },
  {
    nombre: 'Jonathan Roberto Vargas Pino',
    email: 'Robvargas16@gmail.com',
    telefono: '593994927839',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Thalin Michelle Campi Mera',
  },
  {
    nombre: 'Francisco Xavier Cano Calderon',
    email: 'dr.canocalderero@gmail.com',
    telefono: '593959433264',
    estado: 'pendiente',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Thalin Michelle Campi Mera',
  },
  {
    nombre: 'Pamela Zea',
    email: 'pame1385@hotmail.com',
    telefono: '593983814793',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'María Josefina Viteri Viteri',
    email: 'mjviteri@gmail.com',
    telefono: '593991687623',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Thalin Michelle Campi Mera',
  },
  {
    nombre: 'Johnny Fernando Morán Cáceres',
    email: 'jmorancaceres@hotmail.com',
    telefono: '593998420419',
    estado: 'pendiente',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Thalin Michelle Campi Mera',
  },
  {
    nombre: 'Evelyn Alexandra Andrade Cordova',
    email: 'dragastroandradec@gmail.com',
    telefono: '593958919585',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Mayra Alexandra Rodas Robayo',
    email: 'mayrodasro@hotmail.com',
    telefono: '593999774977',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Gladys Bravo',
    email: 'gladyskaro9@hotmail.com',
    telefono: '593999599590',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Jimmy Antonio Siguencia Chalen',
    email: 'jimdigart@hotmail.com',
    telefono: '593999616002',
    estado: 'pendiente',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Mariana Gabriela Orozco Tovar',
    email: 'gabrielaorozco_995@hotmail.com',
    telefono: '593984808389',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Aníbal Rolando Guerrero Portugal',
  },
  {
    nombre: 'María José Alvarado Rivera',
    email: 'majo_alvarado17@hotmail.com',
    telefono: '593981768222',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Rafael Pablo Salgado',
    email: 'rsalgado@gmail.com',
    telefono: '593993118788',
    estado: 'pendiente',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Daniel Molina Marin',
    email: 'dnaiel@gmail.com',
    telefono: '593994706963',
    estado: 'pendiente',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Xavier Francisco Leon De La Torre',
    email: 'xavifranc@yahoo.com',
    telefono: '593988428207',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Fausto Filiberto Moreno Briones',
    email: 'drfaustomoreno@hotmail.com',
    telefono: '593984936138',
    estado: 'pendiente',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: '',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Laura Catalina Romero Ramirez',
    email: 'lcomeror@yahoo.es',
    telefono: '593997554777',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Carlos Alberto Pardo Guanipa',
    email: 'carlospardo891@gmail.com',
    telefono: '593984170842',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Andrea Carina Molina Andrade',
  },
  {
    nombre: 'Fallon Katherine Tayo Roldan',
    email: 'fallontayo@hotmail.com',
    telefono: '593992065732',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Johan Alejandro Alvarez Hernandez',
    email: 'johanalvarez2025@gmail.com',
    telefono: '593958649427',
    estado: 'pendiente',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Marlis Liliana Mojarrango Ulloa',
    email: 'drmojarrango@gmail.com',
    telefono: '593998367051',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Soberania Alayza Rengifo Galindez',
    email: 'sobealay77@gmail.com',
    telefono: '593998983948',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Laura Catalina Romero Ramírez',
    email: 'lcromeror@yahoo.es',
    telefono: '593997554777',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Lucia Alexandra Hernández Ludeña',
    email: 'lhernandezgastro@gmail.com',
    telefono: '593996296210',
    estado: 'confirmado',
    fecha_registro: '2026-09-03',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Oswaldo Jose Blanco Gomez',
    email: 'blancogomezoswaldojose@gmail.com',
    telefono: '593968737613',
    estado: 'confirmado',
    fecha_registro: '2026-09-04',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Alexandra Edith Gallegos Lozano',
    email: 'a.alexa_199@hotmail.com',
    telefono: '593991295222',
    estado: 'confirmado',
    fecha_registro: '2026-09-04',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Juan Carlos Ulloa Correa',
  },
  {
    nombre: 'Pilar Silvania Correa Padilla',
    email: 'p.silvi_3010@hotmail.com',
    telefono: '593985721685',
    estado: 'confirmado',
    fecha_registro: '2026-09-05',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Andrea Carina Molina Andrade',
  },
  {
    nombre: 'María Auxiliadora Castillo',
    email: 'mariuxcv@gmail.com',
    telefono: '593979221654',
    estado: 'confirmado',
    fecha_registro: '2026-09-05',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Aníbal Rolando Guerrero Portugal',
  },
  {
    nombre: 'Leonardo Andrés Moran Cruz',
    email: 'andres_14n@hotmail.com',
    telefono: '593991311463',
    estado: 'confirmado',
    fecha_registro: '2026-09-06',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Maria Silva',
    email: 'mansilva2@hotmail.com',
    telefono: '593996019304',
    estado: 'pendiente',
    fecha_registro: '2026-09-07',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Aníbal Rolando Guerrero Portugal',
  },
  {
    nombre: 'Juan Zúñiga',
    email: 'jcharliez@hotmail.com',
    telefono: '593987475884',
    estado: 'confirmado',
    fecha_registro: '2026-09-07',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Freddy Reinaldo Usca Usca',
  },
  {
    nombre: 'Cecil Giovanni Castellanos Suarez',
    email: 'info@gastrogcastellanos.ec',
    telefono: '593999449188',
    estado: 'confirmado',
    fecha_registro: '2026-09-07',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Cristina Del Rocio Arevalo Molina',
  },
  {
    nombre: 'Laura Jacome',
    email: 'centrodesaludfamiliar@yahoo.es',
    telefono: '593981788810',
    estado: 'confirmado',
    fecha_registro: '2026-09-07',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Pedro Ramiro Vargas Brandt',
  },
  {
    nombre: 'Karla Paulette Ruiz Conforme',
    email: 'karlaruizmed@hotmail.com',
    telefono: '593993785617',
    estado: 'confirmado',
    fecha_registro: '2026-09-07',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Sammy Yepez',
    email: 'dra.sammyepez@outlook.es',
    telefono: '593980525243',
    estado: 'confirmado',
    fecha_registro: '2026-09-07',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Gabriel Gastón Medina Barcia',
  },
  {
    nombre: 'Estefhanie Elizabeth Villalba Leiva',
    email: 'e.villalbaleiva@hotmail.com',
    telefono: '593984055279',
    estado: 'confirmado',
    fecha_registro: '2026-09-07',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Aníbal Rolando Guerrero Portugal',
  },
  {
    nombre: 'Gladys Alexandra Álvarez Torres',
    email: 'g_alexa86@hotmail.com',
    telefono: '593995302046',
    estado: 'confirmado',
    fecha_registro: '2026-09-07',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Andrea Carina Molina Andrade',
  },
  {
    nombre: 'Cesar Olalles',
    email: 'cgolalles@hotmail.com',
    telefono: '593987016323',
    estado: 'confirmado',
    fecha_registro: '2026-09-07',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Juan Pablo Alvarez Duque',
  },
  {
    nombre: 'Ricardo Mantilla',
    email: 'rickardo2203@gmail.com',
    telefono: '593997018152',
    estado: 'confirmado',
    fecha_registro: '2026-09-07',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Juan Pablo Alvarez Duque',
  },
  {
    nombre: 'Steven Almeida',
    email: 'stevenalmeida482@gmail.com',
    telefono: '593980839230',
    estado: 'pendiente',
    fecha_registro: '2026-09-07',
    ciudad: 'Quito',
    localidad: 'Hotel GO',
    fecha_evento: '07 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Juan Pablo Alvarez Duque',
  },
  {
    nombre: 'Byron Villacís',
    email: 'blvn09@hotmail.com',
    telefono: '593992069241',
    estado: 'confirmado',
    fecha_registro: '2026-09-08',
    ciudad: 'Portoviejo',
    localidad: 'Hotel Oro Verde',
    fecha_evento: '11 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Alfredo Macias',
  },
  {
    nombre: 'Eduardo Garcia',
    email: 'eduardogarciasaltos5@gmail.com',
    telefono: '593994608334',
    estado: 'pendiente',
    fecha_registro: '2026-09-08',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Eduardo Garcia Saltos',
    email: 'eduardo-garcia5@hotmail.com',
    telefono: '593994608334',
    estado: 'confirmado',
    fecha_registro: '2026-09-08',
    ciudad: 'Portoviejo',
    localidad: 'Hotel Oro Verde',
    fecha_evento: '11 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Alfredo Macias',
  },
  {
    nombre: 'Fernando Velez Ocampo',
    email: 'dr.velezgastro@gmail.com',
    telefono: '593939138821',
    estado: 'confirmado',
    fecha_registro: '2026-09-09',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Jean Pierre Horna Zhinin',
  },
  {
    nombre: 'Gina Cecibel Mojarrango Ulloa',
    email: 'dracegino@hotmail.es',
    telefono: '593996425969',
    estado: 'confirmado',
    fecha_registro: '2026-09-09',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Dalila Cleopatra Urgiles Guaman',
    email: 'dra.dalilaurgiles@gmail.com',
    telefono: '593987237449',
    estado: 'confirmado',
    fecha_registro: '2026-09-09',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Zamira Garcia Sacoto',
    email: 'zamiragarcia79@hotmail.com',
    telefono: '593989566434',
    estado: 'confirmado',
    fecha_registro: '2026-09-09',
    ciudad: 'Portoviejo',
    localidad: 'Hotel Oro Verde',
    fecha_evento: '11 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Alfredo Macias',
  },
  {
    nombre: 'Xavier Vera',
    email: 'xavierverarteaga@gmail.com',
    telefono: '593993126712',
    estado: 'confirmado',
    fecha_registro: '2026-09-09',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Luis Linzan Villavicencio',
    email: 'gastrolinzan@hotmail.com',
    telefono: '593999757112',
    estado: 'confirmado',
    fecha_registro: '2026-09-09',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'Elizabeth Alava',
    email: 'lizalava83@gmail.com',
    telefono: '593987487525',
    estado: 'confirmado',
    fecha_registro: '2026-09-11',
    ciudad: 'Guayaquil',
    localidad: 'Hotel Sheraton',
    fecha_evento: '09 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Hans Leonardo Villacis Vera',
  },
  {
    nombre: 'César Daniel Ortiz Villavicencio',
    email: 'daniel-8000@hotmail.com',
    telefono: '593991548933',
    estado: 'confirmado',
    fecha_registro: '2026-09-11',
    ciudad: 'Portoviejo',
    localidad: 'Hotel Oro Verde',
    fecha_evento: '11 de Septiembre de 2026',
    especialidad: 'Gastroenterología',
    representante: 'Alfredo Macias',
  },
]

// ── Helpers ──────────────────────────────────────────────────────────────────

const ESTADO_CONFIG: Record<Estado, { label: string; color: string; bg: string; icon: React.ElementType }> = {
  confirmado: { label: 'Confirmado', icon: CheckCircle2, color: '#2fbc80', bg: '#2fbc8018' },
  pendiente: { label: 'Pendiente', icon: Clock, color: '#f6c23e', bg: '#f6c23e18' },
  cancelado: { label: 'Cancelado', icon: Clock, color: '#eb6587', bg: '#eb658718' },
}

function EstadoBadge({ estado }: { estado: Estado }) {
  const cfg = ESTADO_CONFIG[estado]
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium"
      style={{ color: cfg.color, backgroundColor: cfg.bg }}
    >
      <cfg.icon className="h-3 w-3" />
      {cfg.label}
    </span>
  )
}

// ── Datos derivados ───────────────────────────────────────────────────────────

function agg<K extends keyof RegistroAdium>(key: K) {
  const map: Record<string, number> = {}
  REGISTROS.forEach((r) => {
    const v = String(r[key])
    map[v] = (map[v] ?? 0) + 1
  })
  return Object.entries(map)
    .map(([nombre, total]) => ({ nombre, total }))
    .sort((a, b) => b.total - a.total)
}

const POR_CIUDAD = agg('ciudad')
const POR_LOCALIDAD = agg('localidad')
const POR_REPRESENTANTE = agg('representante')

const POR_FECHA = (() => {
  const map: Record<string, number> = {}
  REGISTROS.forEach((r) => { map[r.fecha_registro] = (map[r.fecha_registro] ?? 0) + 1 })
  return Object.entries(map)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([fecha, total]) => ({ fecha, total }))
})()

// ── Ciudad / Localidad con tabs ───────────────────────────────────────────────

type TabCL = 'ciudad' | 'localidad'

const TAB_CONFIG: { key: TabCL; label: string; icon: React.ElementType; data: { nombre: string; total: number }[]; yWidth: number }[] = [
  { key: 'ciudad', label: 'Ciudad', icon: MapPin, data: POR_CIUDAD, yWidth: 90 },
  { key: 'localidad', label: 'Localidad', icon: Building2, data: POR_LOCALIDAD, yWidth: 130 },
]

function CiudadLocalidadCard() {
  const [tab, setTab] = useState<TabCL>('ciudad')
  const cfg = TAB_CONFIG.find((t) => t.key === tab)!

  return (
    <Card className="border border-gray-200 dark:border-gray-700 h-full flex flex-col">
      <CardHeader className="pb-2 flex flex-row items-center gap-2 space-y-0">
        <cfg.icon className="h-4 w-4 text-muted-foreground" />
        <CardTitle className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">Por {cfg.label}</CardTitle>
      </CardHeader>
      <CardContent className="pt-0 pb-0 px-4 flex-1 flex flex-col min-h-0">
        <div className="flex-1 min-h-0">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={cfg.data} layout="vertical" margin={{ left: 0, right: 40, top: 4, bottom: 4 }}>
              <XAxis type="number" hide />
              <YAxis dataKey="nombre" type="category" tickLine={false} axisLine={false} width={cfg.yWidth} tick={{ fontSize: 10 }} interval={0} />
              <Tooltip formatter={(v: number) => [`${v} registro${v !== 1 ? 's' : ''}`, '']} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
              <Bar dataKey="total" radius={[0, 4, 4, 0]}>
                {cfg.data.map((_, idx) => (
                  <Cell key={idx} fill={SHADES[idx % SHADES.length]} />
                ))}
                <LabelList dataKey="total" position="right" style={{ fontSize: 11, fill: '#6b7280' }} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Tabs inferiores */}
        <div className="flex mt-2 -mx-4 shrink-0">
          {TAB_CONFIG.map(({ key, label, icon: Icon }) => (
            <button
              key={key}
              onClick={() => setTab(key)}
              className="w-1/2 flex items-center justify-center gap-1.5 py-2.5 text-xs font-medium transition-colors border-t-2"
              style={
                tab === key
                  ? { color: PURPLE, borderColor: PURPLE }
                  : { color: '#9ca3af', borderColor: '#f3f4f6' }
              }
            >
              <Icon className="h-3.5 w-3.5" />
              {label}
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}

// ── KPI Card ─────────────────────────────────────────────────────────────────

function KpiCard({ label, value, icon: Icon }: { label: string; value: string | number; icon: React.ElementType }) {
  return (
    <div
      className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-card px-4 py-4 flex flex-col gap-2"
      style={{ backgroundImage: `linear-gradient(to right, ${PURPLE_LIGHT}, transparent 60%)` }}
    >
      <p className="text-[11px] font-medium text-muted-foreground uppercase tracking-wide">{label}</p>
      <div className="flex items-center gap-3">
        <Icon className="h-8 w-8 shrink-0" style={{ color: PURPLE }} />
        <span className="text-3xl font-bold text-foreground">{value}</span>
      </div>
    </div>
  )
}

// ── Página principal ─────────────────────────────────────────────────────────

const CIUDADES = ['todas', ...Array.from(new Set(REGISTROS.map((r) => r.ciudad))).sort()]

function descargarExcel(registros: RegistroAdium[]) {
  const rows = registros.map((r) => ({
    Nombre: r.nombre,
    Email: r.email,
    Teléfono: r.telefono,
    Ciudad: r.ciudad,
    Localidad: r.localidad,
    'Fecha Evento': r.fecha_evento,
    Representante: r.representante,
    Especialidad: r.especialidad,
    Estado: r.estado,
  }))
  const ws = XLSX.utils.json_to_sheet(rows)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Registros')
  XLSX.writeFile(wb, 'registros-vozama.xlsx')
}

export function AdiumRegistrosPage() {
  useDocumentTitle('Registros Vozama')
  const navigate = useNavigate()

  const [search, setSearch] = useState('')
  const [filtroEstado, setFiltroEstado] = useState<'todos' | Estado>('todos')
  const [filtroCiudad, setFiltroCiudad] = useState<string>('todas')

  const filtered = REGISTROS.filter((r) => {
    const q = search.toLowerCase()
    const matchSearch =
      !q ||
      r.nombre.toLowerCase().includes(q) ||
      r.email.toLowerCase().includes(q) ||
      r.ciudad.toLowerCase().includes(q) ||
      r.representante.toLowerCase().includes(q)
    const matchEstado = filtroEstado === 'todos' || r.estado === filtroEstado
    const matchCiudad = filtroCiudad === 'todas' || r.ciudad === filtroCiudad
    return matchSearch && matchEstado && matchCiudad
  })

  const confirmados = REGISTROS.filter((r) => r.estado === 'confirmado').length
  const pendientes = REGISTROS.filter((r) => r.estado === 'pendiente').length

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 p-6 space-y-6">

      {/* Header */}
      <Card className="border border-gray-200 dark:border-gray-700">
        <CardContent className="py-4 px-6">
          <div className="flex items-center justify-between gap-4">
            <div>
              <h1 className="text-xl font-bold text-foreground">{EVENTO.nombre}</h1>
              <p className="text-sm text-muted-foreground mt-0.5">{EVENTO.subtitulo}</p>
            </div>
            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate('/registros/adium/encuesta')}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors text-white"
                style={{ backgroundColor: PURPLE }}
              >
                <ClipboardList className="h-3.5 w-3.5" />
                Ver encuesta
              </button>
              <img src="/logo-tonal-negro.png" alt="Tonal" className="h-10 w-auto dark:invert" />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* KPIs */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <KpiCard icon={Users} label="Total registros" value={REGISTROS.length} />
        <KpiCard icon={CheckCircle2} label="Confirmados" value={confirmados} />
        <KpiCard icon={Clock} label="Pendientes" value={pendientes} />
      </div>

      {/* Ciudad / Localidad + Representante — 50/50 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <CiudadLocalidadCard />

        {/* Por representante */}
        <Card className="border border-gray-200 dark:border-gray-700">
        <CardHeader className="pb-2 flex flex-row items-center gap-2 space-y-0">
          <UserSearch className="h-4 w-4 text-muted-foreground" />
          <CardTitle className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">Por representante</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="overflow-y-auto" style={{ maxHeight: (POR_REPRESENTANTE.length * 44 + 20) / 2 }}>
            <ResponsiveContainer width="100%" height={POR_REPRESENTANTE.length * 44 + 20}>
              <BarChart data={POR_REPRESENTANTE} layout="vertical" margin={{ left: 0, right: 40, top: 4, bottom: 4 }}>
                <XAxis type="number" hide />
                <YAxis dataKey="nombre" type="category" tickLine={false} axisLine={false} width={220} tick={{ fontSize: 10 }} interval={0} />
                <Tooltip formatter={(v: number) => [`${v} registro${v !== 1 ? 's' : ''}`, '']} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
                <Bar dataKey="total" radius={[0, 4, 4, 0]} fill={PURPLE}>
                  <LabelList dataKey="total" position="right" style={{ fontSize: 11, fill: '#6b7280' }} />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </Card>
      </div>

      {/* Gráfica de fecha — fila completa */}
      <Card className="border border-gray-200 dark:border-gray-700">
        <CardHeader className="pb-2 flex flex-row items-center gap-2 space-y-0">
          <Users className="h-4 w-4 text-muted-foreground" />
          <CardTitle className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">Registros por fecha</CardTitle>
        </CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={POR_FECHA} margin={{ left: 0, right: 24, top: 8, bottom: 4 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis dataKey="fecha" tick={{ fontSize: 11 }} tickLine={false} axisLine={false} />
              <YAxis allowDecimals={false} tickLine={false} axisLine={false} tick={{ fontSize: 11 }} width={24} />
              <Tooltip formatter={(v: number) => [`${v} registro${v !== 1 ? 's' : ''}`, '']} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
              <Line
                type="monotone"
                dataKey="total"
                stroke={PURPLE}
                strokeWidth={2.5}
                dot={{ fill: PURPLE, r: 5 }}
                activeDot={{ r: 7 }}
              >
                <LabelList dataKey="total" position="top" offset={10} style={{ fontSize: 11, fontWeight: 600, fill: PURPLE }} />
              </Line>
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      {/* Filtros */}
      <div className="flex flex-col gap-3">
        <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center">
          <div className="relative flex-1 max-w-xs">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <input
              type="text"
              placeholder="Buscar nombre, ciudad, representante..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-9 pr-3 py-1.5 text-sm border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-card text-foreground placeholder:text-muted-foreground focus:outline-none"
            />
          </div>
          <div className="flex gap-2 flex-wrap">
            {(['todos', 'confirmado', 'pendiente'] as const).map((e) => (
              <button
                key={e}
                onClick={() => setFiltroEstado(e)}
                className="px-3 py-1.5 rounded-md text-xs font-medium transition-colors"
                style={
                  filtroEstado === e
                    ? { backgroundColor: PURPLE, color: '#fff' }
                    : { backgroundColor: `${PURPLE}14`, color: PURPLE }
                }
              >
                {e === 'todos' ? 'Todos' : ESTADO_CONFIG[e].label}
              </button>
            ))}
          </div>
          <button
            onClick={() => descargarExcel(filtered)}
            className="ml-auto flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors border border-gray-200 dark:border-gray-700 text-muted-foreground hover:bg-gray-100 dark:hover:bg-gray-800"
          >
            <Download className="h-3.5 w-3.5" />
            Descargar Excel
          </button>
        </div>

        {/* Filtro ciudad */}
        <div className="flex gap-2 flex-wrap">
          {CIUDADES.map((c) => (
            <button
              key={c}
              onClick={() => setFiltroCiudad(c)}
              className="px-3 py-1.5 rounded-md text-xs font-medium transition-colors capitalize"
              style={
                filtroCiudad === c
                  ? { backgroundColor: PURPLE, color: '#fff' }
                  : { backgroundColor: `${PURPLE}14`, color: PURPLE }
              }
            >
              {c === 'todas' ? 'Todas las ciudades' : c}
            </button>
          ))}
        </div>
      </div>

      {/* Tabla */}
      <Card className="border border-gray-200 dark:border-gray-700">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">
            {filtered.length} registro{filtered.length !== 1 ? 's' : ''}
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50">
                  {['Nombre', 'Email', 'Teléfono', 'Ciudad', 'Localidad', 'Fecha evento', 'Representante', 'Estado'].map((h) => (
                    <th key={h} className="text-left px-4 py-2.5 text-xs font-semibold text-muted-foreground uppercase tracking-wide whitespace-nowrap">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((r, idx) => (
                  <tr
                    key={idx}
                    className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-900/30 transition-colors"
                  >
                    <td className="px-4 py-2.5 font-medium text-foreground whitespace-nowrap">{r.nombre}</td>
                    <td className="px-4 py-2.5 text-muted-foreground text-xs">{r.email}</td>
                    <td className="px-4 py-2.5 text-muted-foreground text-xs whitespace-nowrap">{r.telefono}</td>
                    <td className="px-4 py-2.5 text-muted-foreground whitespace-nowrap">{r.ciudad}</td>
                    <td className="px-4 py-2.5 text-muted-foreground whitespace-nowrap">{r.localidad}</td>
                    <td className="px-4 py-2.5 text-muted-foreground whitespace-nowrap text-xs">{r.fecha_evento}</td>
                    <td className="px-4 py-2.5 text-muted-foreground text-xs">{r.representante}</td>
                    <td className="px-4 py-2.5"><EstadoBadge estado={r.estado} /></td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={8} className="px-4 py-8 text-center text-muted-foreground text-sm">
                      No se encontraron registros.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>

      <p className="text-center text-xs text-muted-foreground/40 pb-2">
        Tonal Strategies · {EVENTO.periodo} · Adium Vonoprazan
      </p>
    </div>
  )
}

